import { Box, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useStyles } from "../ConnectionBar.styles";
import { useTranslation } from "react-i18next";

export const BarReferences = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Box className={classes.referencesContainer}>
            <Box className={classes.referenceItem}>
                <FiberManualRecordIcon className={`${classes.referenceIcon} ${classes.connectedIcon}`} />
                <Typography variant="h6" className={classes.referenceTitle}>
                    {t("locations.mill_network_details.connected")}
                </Typography>
            </Box>
            <Box className={classes.referenceItem}>
                <FiberManualRecordIcon className={`${classes.referenceIcon} ${classes.disconnectedIcon}`} />
                <Typography variant="h6" className={classes.referenceTitle}>
                    {t("locations.mill_network_details.disconnected")}
                </Typography>
            </Box>
        </Box>
    );
};
